import React, { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';

export default function UpdateToast() {
  const [visible, setVisible] = useState(false);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    function onUpdateReady() {
      if (window.location.pathname === '/kiosk') {
        // 키오스크: 즉시 자동 업데이트
        window.__pendingSW?.postMessage({ type: 'SKIP_WAITING' });
      } else {
        setVisible(true);
      }
    }
    window.addEventListener('swUpdateReady', onUpdateReady);
    return () => window.removeEventListener('swUpdateReady', onUpdateReady);
  }, []);

  function handleUpdate() {
    setUpdating(true);
    window.__pendingSW?.postMessage({ type: 'SKIP_WAITING' });
    // controllerchange 이벤트가 발생하면 pushNotifications.js에서 reload 처리
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 bg-gray-900 dark:bg-gray-800 text-white px-4 py-3 rounded-2xl shadow-2xl border border-gray-700 max-w-sm w-full mx-4">
      <RefreshCw className={`w-4 h-4 text-primary-400 flex-shrink-0 ${updating ? 'animate-spin' : ''}`} />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium leading-tight">새 버전이 있습니다</p>
        <p className="text-xs text-gray-400 mt-0.5">업데이트 후 자동으로 새로고침됩니다.</p>
      </div>
      <button
        onClick={handleUpdate}
        disabled={updating}
        className="flex-shrink-0 bg-primary-600 hover:bg-primary-700 disabled:opacity-60 text-white text-xs font-medium px-3 py-1.5 rounded-lg transition-colors"
      >
        {updating ? '적용 중...' : '업데이트'}
      </button>
      {!updating && (
        <button
          onClick={() => setVisible(false)}
          className="flex-shrink-0 text-gray-500 hover:text-gray-300 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
